import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-edit" }
const _hoisted_2 = { class: "form-group" }
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = { class: "form-group" }
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = { class: "form-group" }
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = { class: "form-group" }

import { ref, watch } from "vue";

interface Props {
  block: any;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'TextEdit',
  props: {
    block: {}
  },
  emits: ["update"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const localBlock = ref(JSON.parse(JSON.stringify(props.block)));

// Estilos padrão se não existirem
if (!localBlock.value.style) {
  localBlock.value.style = {
    fontSize: "14px",
    lineHeight: "1.6",
    textAlign: "left",
    color: "#000000",
    fontWeight: "normal",
    fontStyle: "normal",
  };
}

watch(
  () => props.block,
  (newBlock) => {
    localBlock.value = JSON.parse(JSON.stringify(newBlock));
  },
  { deep: true }
);

function onChange() {
  emit("update", localBlock.value);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[17] || (_cache[17] = _createElementVNode("h4", null, "Editar Texto", -1)),
    _createElementVNode("div", _hoisted_2, [
      _cache[7] || (_cache[7] = _createElementVNode("label", null, "Conteúdo:", -1)),
      _withDirectives(_createElementVNode("textarea", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((localBlock.value.data.content) = $event)),
        onInput: onChange,
        rows: "6",
        class: "text-content",
        placeholder: "Digite o conteúdo do texto..."
      }, null, 544), [
        [_vModelText, localBlock.value.data.content]
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _cache[9] || (_cache[9] = _createElementVNode("label", null, "Tamanho da Fonte:", -1)),
      _withDirectives(_createElementVNode("select", {
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((localBlock.value.style.fontSize) = $event)),
        onChange: onChange
      }, [...(_cache[8] || (_cache[8] = [
        _createStaticVNode("<option value=\"12px\" data-v-184668fe>Pequeno (12px)</option><option value=\"14px\" data-v-184668fe>Normal (14px)</option><option value=\"16px\" data-v-184668fe>Médio (16px)</option><option value=\"18px\" data-v-184668fe>Grande (18px)</option><option value=\"20px\" data-v-184668fe>Muito Grande (20px)</option>", 5)
      ]))], 544), [
        [_vModelSelect, localBlock.value.style.fontSize]
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _cache[11] || (_cache[11] = _createElementVNode("label", null, "Espaçamento entre Linhas:", -1)),
      _withDirectives(_createElementVNode("select", {
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((localBlock.value.style.lineHeight) = $event)),
        onChange: onChange
      }, [...(_cache[10] || (_cache[10] = [
        _createElementVNode("option", { value: "1.2" }, "Compacto (1.2)", -1),
        _createElementVNode("option", { value: "1.4" }, "Normal (1.4)", -1),
        _createElementVNode("option", { value: "1.6" }, "Confortável (1.6)", -1),
        _createElementVNode("option", { value: "1.8" }, "Amplo (1.8)", -1)
      ]))], 544), [
        [_vModelSelect, localBlock.value.style.lineHeight]
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _cache[13] || (_cache[13] = _createElementVNode("label", null, "Alinhamento:", -1)),
      _withDirectives(_createElementVNode("select", {
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((localBlock.value.style.textAlign) = $event)),
        onChange: onChange
      }, [...(_cache[12] || (_cache[12] = [
        _createElementVNode("option", { value: "left" }, "Esquerda", -1),
        _createElementVNode("option", { value: "center" }, "Centro", -1),
        _createElementVNode("option", { value: "right" }, "Direita", -1),
        _createElementVNode("option", { value: "justify" }, "Justificado", -1)
      ]))], 544), [
        [_vModelSelect, localBlock.value.style.textAlign]
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _cache[14] || (_cache[14] = _createElementVNode("label", null, "Cor do Texto:", -1)),
      _withDirectives(_createElementVNode("input", {
        type: "color",
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((localBlock.value.style.color) = $event)),
        onChange: onChange
      }, null, 544), [
        [_vModelText, localBlock.value.style.color]
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("label", null, [
        _withDirectives(_createElementVNode("input", {
          type: "checkbox",
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((localBlock.value.style.fontWeight) = $event)),
          "true-value": "bold",
          "false-value": "normal",
          onChange: onChange
        }, null, 544), [
          [_vModelCheckbox, localBlock.value.style.fontWeight]
        ]),
        _cache[15] || (_cache[15] = _createTextVNode(" Texto em Negrito ", -1))
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("label", null, [
        _withDirectives(_createElementVNode("input", {
          type: "checkbox",
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((localBlock.value.style.fontStyle) = $event)),
          "true-value": "italic",
          "false-value": "normal",
          onChange: onChange
        }, null, 544), [
          [_vModelCheckbox, localBlock.value.style.fontStyle]
        ]),
        _cache[16] || (_cache[16] = _createTextVNode(" Texto em Itálico ", -1))
      ])
    ])
  ]))
}
}

})